import { propertyValue } from './dood-block-config';
import { doodModalConfig } from './dood-modal-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const COMOPRODUCTSSELECTIONMODAL_LEGACY_FIELD_ORDER = [
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  comoProductsSelectionModalDescriptor: _generatedComoProductsSelectionModalDescriptor,
  comoProductsSelectionModalModalDefinition,
  comoProductsSelectionModalDashboardLayout,
  comoProductsSelectionModalConfig,
  comoProductsSelectionModalResolveConfig,
  comoProductsSelectionModalProperties,
} = doodModalConfig(
  {
    name: "Como - Products selection modal",
    handle: "como-products-selection-modal",
    internal_name: "ComoProductsSelectionModal",
    componentType: 'ComoProductsSelectionModalComponent',
    category: 'modal',
    description: "Como - Products selection modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "como-products-selection-modal",
    allowed_in: ["ModalBlock"],
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["background_color"],
          },
        ],
      },
    ],
  })
);

export function comoProductsSelectionModalDescriptor(): IBlockDescriptor;
export function comoProductsSelectionModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function comoProductsSelectionModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedComoProductsSelectionModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedComoProductsSelectionModalDescriptor, comoProductsSelectionModalProperties, fieldOrder);
}

export {
  comoProductsSelectionModalModalDefinition,
  comoProductsSelectionModalDashboardLayout,
  comoProductsSelectionModalProperties,
  comoProductsSelectionModalConfig,
  comoProductsSelectionModalResolveConfig,
};

export type ComoProductsSelectionModalConfig = typeof comoProductsSelectionModalConfig;
